import {Injectable, inject} from '@angular/core';
import {EamlRequest, IfsRequest} from '../../../_data/reports/ifs/ifs-request';
import {Observable} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {EamlReport, IfsReport} from '../../../_data/reports/ifs/ifs-report';
import {map} from 'rxjs/operators';
import {ApiEndpoints} from '../../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class IfsReportsService {
  private http = inject(HttpClient);
  private apiEndpoints = inject(ApiEndpoints);


  getReport(ifsRequest: IfsRequest): Observable<HttpResponse<IfsReport>> {
    console.info('Pulling ifs report...');
    return this.http.post<IfsReport>(this.apiEndpoints.ifsPullIfs, ifsRequest, {observe: 'response'});
  }

  getEamlReport(eamlRequest: EamlRequest): Observable<HttpResponse<EamlReport>> {
    console.info('Pulling enhanced aml report...');
    return this.http.post(this.apiEndpoints.ifsPullEaml, eamlRequest, {observe: 'response'})
      .pipe(map((r: HttpResponse<any>) => new HttpResponse<EamlReport>({
        status: r.status,
        body:   {
          ifsReport:      r.body.ifsReport,
          consumerReport: JSON.parse(r.body.consumerReport.jsonReport.replace(/\u0003/g, ''))
        }
      })));
  }

}
